import {FC} from 'react'
import {Modal} from 'react-bootstrap-v5'

interface Props {
  show: boolean
  title: string
  description?: string
  // "confirm" (default) shows Cancel + Accept. "notice" shows a single Accept
  // button, used for inline validation errors so we don't fall back to
  // window.alert() and break the Nobilis look.
  variant?: 'confirm' | 'notice'
  cancelLabel?: string
  acceptLabel?: string
  loading?: boolean
  onCancel?: () => void
  onAccept: () => void
}

// Reuses the .decline-modal-* styles (see _nb-modal-wl.scss) so this dialog
// matches the rest of the Nobilis admin surface (Oswald title, centered body,
// outline Cancel + solid black Accept). Kept dependency-free so any admin
// screen that needs a Cancel/Accept prompt (or a single-button notice) can
// import it.
export const ConfirmDialog: FC<Props> = ({
  show,
  title,
  description,
  variant = 'confirm',
  cancelLabel = 'Cancel',
  acceptLabel = 'Accept',
  loading = false,
  onCancel,
  onAccept,
}) => {
  const isNotice = variant === 'notice'
  const handleHide = () => {
    if (loading) return
    if (isNotice) {
      onAccept()
    } else if (onCancel) {
      onCancel()
    }
  }

  return (
    <Modal
      show={show}
      onHide={handleHide}
      centered
      backdrop='static'
      dialogClassName='decline-modal'
      contentClassName='decline-modal-content'
      backdropClassName='decline-modal-backdrop'
    >
      <div className='decline-modal-body'>
        <div className='decline-modal-title'>{title}</div>
        {description && <div className='decline-modal-description'>{description}</div>}
        <div className='decline-modal-actions'>
          {!isNotice && (
            <button
              type='button'
              className='decline-modal-btn-cancel'
              onClick={onCancel}
              disabled={loading}
            >
              <div className='decline-modal-btn-text'>{cancelLabel}</div>
            </button>
          )}
          <button
            type='button'
            className='decline-modal-btn-decline'
            onClick={onAccept}
            disabled={loading}
          >
            {loading ? (
              <div className='decline-modal-btn-text'>
                Please wait...
                <span
                  className='spinner-border spinner-border-sm align-middle ms-2'
                  role='status'
                  aria-hidden='true'
                />
              </div>
            ) : (
              <>
                <div className='decline-modal-btn-text'>{acceptLabel}</div>
                <img
                  src='/media/svg/nobilis/vector1.svg'
                  alt=''
                  className='nb-btn-icon nb-btn-icon--white'
                />
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmDialog
